/**
 * D-068: montaj kaydının (FM-0012) sözlükleri, hâl kuralı ve uç yanıtlarının tipleri. API ve web aynı tipleri okur.
 * Saklanan değerler kalıcıdır (S4): `montaj_kaydi.tur`, `montaj_birim.durum`, `montaj_birim.rol`, belge aileleri.
 */
import { fm12SatirSayisi } from "./fm12.js";
/** rapor: rapor PDF'i yüklendi, satırları girdi excel'inden okunur · form: FM-0012 ekranda doldurulur (P2). */
export const MONTAJ_KAYIT_TURLERI = ["rapor", "form"];
/** Birim durumu: boş ya da "sokuldu" (montajdan sonra söküldü; formda "REMOVED"). Satır durumundan AYRI sözlüktür. */
export const MONTAJ_BIRIM_DURUMLARI = ["sokuldu"];
/** C = Choke · K = Kill; yalnız 3. ve 6. satırın birimlerinde. */
export const MONTAJ_ROLLER = ["C", "K"];
/** Assembly SN'in çözüldüğü kimlik uzayı (söküm ile aynı dört değer). */
export const MONTAJ_SN_UZAYLARI = ["ASSEMBLY", "MT_WELDMENT", "NO_MRB", "UNRESOLVED"];
/** Belge aileleri (`dokuman.aile`): rapor PDF'i · okunan girdi excel'i (D-068, yeni) · okunmayan ek excel (var). */
export const MONTAJ_BELGE_AILESI = { rapor: "FM-0012", girdi: "FM-0012-input", ekExcel: "FM-0012-excel" };
/** Dönüştürücü türü (`donusum_isi.belge_turu`) ve olay nesne tipi. Olay nesne tipinin TEK tanımı budur (sunucu buradan içe aktarır). */
export const MONTAJ_DONUSUM_TURU = "assembly";
export const MONTAJ_OLAY_NESNESI = "montaj";
export const MONTAJ_HALLERI = ["girdi_bekliyor", "okundu", "girdisiz", "form_acik", "imzali_bekliyor", "form_kapali"];
/**
 * Kaydın hâli; ayrı kolonda tutulmaz. rapor: okuma varsa "okundu" (kapalı olsun olmasın); okuma yoksa kapalıysa "girdisiz",
 * değilse "girdi_bekliyor". form: kapalıysa "form_kapali", print-out işaretliyse "imzali_bekliyor", değilse "form_acik".
 * `rapor` türü kayıt açan her yol `raporDokumanId`'yi yazar (boş kalamaz). P1'de `kapali` kolonunu okuyan TEK yer bu fonksiyondur.
 */
export function montajHali(k) {
    if (k.tur === "form")
        return k.kapali ? "form_kapali" : k.printed ? "imzali_bekliyor" : "form_acik";
    return k.okumaVar ? "okundu" : k.kapali ? "girdisiz" : "girdi_bekliyor";
}
/**
 * Formun doluluğu: durumu yazılmış satır / basımın satır sayısı. A basımında 30. satır basılı değildir ve sayılmaz;
 * basım bilinmiyorsa payda 30'dur. Hücresi boş olup yalnız liste birimi taşıyan satır "dolu" sayılmaz (durum boştur; KP-15).
 */
export function montajDoluluk(satirlar, basim) {
    const toplam = fm12SatirSayisi(basim);
    return { dolu: satirlar.filter((s) => s.sira >= 1 && s.sira <= toplam && Boolean(s.durum)).length, toplam };
}
/** Kesirli inç yazımında kabul edilen paydalar (motorun ölçü kuralıyla aynı liste). */
const OLCU_KESIR_PAYDALARI = [2, 4, 8, 16, 32];
/**
 * Ekrandaki ölçü girdisi (inç): "3.625", "3,625", "3-7/16", "3 7/16" → { deger, yazim }; boş → { deger: null, yazim: null }
 * (ölçü silinir); okunamıyorsa null (istek gönderilmez).
 * - Ondalık ayırıcı nokta ya da virgüldür; tam sayı da olur. Değer yazıldığı gibi alınır, yuvarlanmaz.
 * - Kesirli inç: tam kısım, boşluk ya da tire, pay / payda. Payda 2, 4, 8, 16, 32; pay paydadan küçük. Sonuç tam + pay / payda,
 *   en çok dört ondalık, yarım yukarı (assembly motorunun Yöntem §4.8 kuralıyla aynı hesap: "3-7/16" → 3.4375). Tam kısmı
 *   olmayan kesir ("3/4") çevrilmez.
 * - Sıfır, eksi değer, harfli ya da başka türlü yazım okunamaz sayılır. Akla yatkınlık aralığı (`MONTAJ_OLCU_ARALIGI`) burada
 *   DENETLENMEZ; onu sunucu denetler.
 * `yazim` yalnız kesirli girdide doludur (girilen metin, baş ve son boşluğu atılmış); `montaj_olcum.yazim`'a yazılır.
 */
export function montajOlcuCoz(metin) {
    const t = metin.trim();
    if (!t)
        return { deger: null, yazim: null };
    if (/^\d+(?:[.,]\d+)?$/.test(t)) {
        const deger = Number(t.replace(",", "."));
        return Number.isFinite(deger) && deger > 0 ? { deger, yazim: null } : null;
    }
    const k = /^(\d+)[\s-]+(\d+)\/(\d+)$/.exec(t);
    if (!k)
        return null;
    const tam = Number(k[1]);
    const pay = Number(k[2]);
    const payda = Number(k[3]);
    if (!OLCU_KESIR_PAYDALARI.includes(payda) || pay >= payda)
        return null;
    // On binde bir cinsinden tam sayı, yarım yukarı: ((tam × payda + pay) × 10000 × 2 + payda) ÷ (2 × payda), aşağı yuvarlanır.
    const ust = (tam * payda + pay) * 20000 + payda;
    if (!Number.isSafeInteger(ust))
        return null;
    const deger = Math.floor(ust / (2 * payda)) / 10000;
    return deger > 0 ? { deger, yazim: t } : null;
}
//# sourceMappingURL=montaj.js.map